<template>
  <footer class="footer">
    <div class="footer-container reveal">
      <div class="footer-content">
        <div class="footer-brand">
          <div class="logo-wrapper">
            <div class="logo-glow"></div>
            <a href="/" class="footer-logo-link">
              <img
                src="../assets/images/Bizz.png"
                alt="Bizz Logo"
                class="footer-logo"
              />
            </a>
          </div>
          <p class="footer-tagline">
            Empowering entrepreneurs with <br />intelligent business automation.
          </p>
          <p class="footer-copyright">Copyright © 2026 — Bizzento Inc.</p>
        </div>

        <div class="footer-links-group">
          <div class="footer-section reveal delay-1">
            <h3 class="footer-title">Meet the Founders</h3>
            <div class="founders-grid">
              <div class="founder-item">
                <div class="image-container">
                  <img
                    src="https://ui-avatars.com/api/?name=Shruthi+Rao&background=f5e5b0&color=1a1a1a&bold=true"
                    alt="Shruthi Rao"
                    class="founder-img"
                  />
                  <div class="image-ring"></div>
                </div>
                <div class="founder-info">
                  <a
                    href="https://shruthirrao.com"
                    target="_blank"
                    class="founder-name"
                    >Shruthi Rao</a
                  >
                  <span class="founder-role">Strategy & Product</span>
                </div>
              </div>

              <div class="founder-item">
                <div class="image-container">
                  <img
                    src="https://ui-avatars.com/api/?name=Vipandeep+Singh&background=faefca&color=1a1a1a&bold=true"
                    alt="Vipandeep Singh"
                    class="founder-img"
                  />
                  <div class="image-ring"></div>
                </div>
                <div class="founder-info">
                  <a
                    href="https://vipandeepsingh.in"
                    target="_blank"
                    class="founder-name"
                    >Vipandeep Singh</a
                  >
                  <span class="founder-role">Tech & Intelligence</span>
                </div>
              </div>



            </div>
          </div>

          <div class="footer-section reveal delay-2">
            <h3 class="footer-title">Contact</h3>
            <a href="mailto:contact@bizzento.com" class="footer-link">
              contact@bizzento.com
              </a>
            <!--
            <div class="footer-legal-links">
              <a href="#" class="legal-link">Privacy Policy</a>
              <a href="#" class="legal-link">Terms of Service</a>
            </div>
          -->
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  --bg-warm-base: #f2eee0;
  --sunlight-glow: #faefca;
  --soft-gold: #f5e5b0;
  --dark-accent: #1a1a1a;
  --text-muted: #4a3728;

  position: relative;
  width: 100%;
  padding: 100px 24px 60px;
  background-color: var(--bg-warm-base);
  background-image: radial-gradient(
      at 0% 100%,
      var(--sunlight-glow) 0%,
      transparent 40%
    ),
    radial-gradient(at 100% 0%, var(--soft-gold) 0%, transparent 30%);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 80px;
}

.footer-brand {
  flex: 0.8;
  text-align: left;
}

.logo-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 24px;
}

.logo-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 140px;
  height: 70px;
  background: var(--soft-gold);
  filter: blur(45px);
  opacity: 0.6;
  z-index: 1;
}

.footer-logo {
  height: 72px;
  position: relative;
  z-index: 2;
  transition: transform 0.3s ease;
}

.footer-tagline {
  font-size: 1.1rem;
  color: var(--text-muted);
  line-height: 1.6;
  margin-bottom: 24px;
}

.footer-copyright {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text-muted);
  opacity: 0.6;
}

.footer-links-group {
  display: flex;
  flex: 2;
  justify-content: flex-end;
  gap: 100px;
}

.footer-section {
  display: flex;
  flex-direction: column;
}

.footer-title {
  font-size: 0.85rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  text-decoration: underline;
  color: var(--dark-accent);
  margin-bottom: 32px;
}

.founders-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.founder-item {
  display: flex;
  align-items: center;
  gap: 16px;
}

.image-container {
  position: relative;
  width: 60px;
  height: 60px;
}

.founder-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  position: relative;
  z-index: 2;
  background: white; /* Ensures the animated SVG has a clean background */
  border: 2px solid white;
}

.image-ring {
  position: absolute;
  top: -3px;
  left: -3px;
  right: -3px;
  bottom: -3px;
  border-radius: 50%;
  border: 1px solid var(--soft-gold);
  z-index: 1;
}

.founder-info {
  display: flex;
  flex-direction: column;
}

.founder-name {
  font-weight: 700;
  font-size: 1rem;
  color: var(--dark-accent);
  text-decoration: none;
  transition: color 0.2s;
}

.founder-name:hover {
  color: #bfa14d;
}

.founder-role {
  font-size: 0.8rem;
  color: var(--text-muted);
  opacity: 0.8;
}

.footer-link {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--dark-accent);
  text-decoration: none;
  margin-bottom: 24px;
}

.footer-legal-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.legal-link {
  font-size: 0.85rem;
  color: var(--text-muted);
  text-decoration: none;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.legal-link:hover {
  opacity: 1;
}

@media (max-width: 1024px) {
  .footer-links-group {
    gap: 50px;
  }
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 60px;
  }
  .footer-links-group {
    flex-direction: column;
    justify-content: flex-start;
    gap: 40px;
  }
}
</style>

<script>
export default {
  name: 'FooterComponent',
};
</script>
